import React from 'react'
import "../styles/FeedbackSection.css"
import RestartButton from './RestartButton'

const FeedbackSection = ({selectedActor, incorrectSelection, currentActor, completeConnection, connectedActors}) => {
  return (
    <div className="feedback-section-container">
        {selectedActor && (
        <>
          
          {incorrectSelection ? (
            <>
                <h2>{selectedActor} ❌</h2>
            </>
          )
          :
          (
            <>
                <h2>{selectedActor} ✅</h2>
            </>
          )}
          </>
        )}
        {completeConnection && (
          <>
            <h2>Connected!</h2>
            <RestartButton/>
          </>
        )}
    </div>
  )
}

export default FeedbackSection